const $ = jQuery.noConflict();

'use strict';
const infoBanner = {
	$infoBannerImages: $('.js-info-banner-images'),
	$infoBannerImage: $('.js-info-banner-main-img-wrap'),
	$infoBannerCol: $('.js-info-banner-col'),

	init: function() {
		this.bindEvents();
		this.appendImg();
	},

	bindEvents: function() {
		$(window).resize(function() {
			infoBanner.appendImg();
		});
	},

	appendImg: function() {
		if ($(window).width() < 992) {
			infoBanner.$infoBannerImage.appendTo(infoBanner.$infoBannerImages);
		} else {
			infoBanner.$infoBannerImage.appendTo(infoBanner.$infoBannerCol);
		}
	},

};

export default infoBanner;
